import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: { defaultMessage: 'My dashboard' },
});
